<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit Vertical
            </h2>
        </template>

        <vertical-form :vertical="vertical" :action="route('verticals.update', vertical.id)" button="Update"></vertical-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import VerticalForm from './Form';

    export default {
        props: ['vertical'],

        components: {
            AppLayout,
            VerticalForm,
        },
    }
</script>
